import { useGetMeQuery } from "@/states/common/common.api";
import Cookies from "js-cookie";
import { useMemo } from "react";

function useAuth() {
  const user_id = Cookies.get("user_id");

  // Early return if user_id is missing
  const shouldSkip = !user_id;

  const {
    data: userData,
    error,
    isLoading,
  } = useGetMeQuery({ user_id: Number(user_id) }, { skip: shouldSkip });

  // Memoize the returned value to avoid unnecessary re-renders
  return useMemo(
    () => ({
      userData,
      isLoading,
      error,
      isAuthenticated: !!userData,
    }),
    [userData, isLoading, error]
  );
}

export default useAuth;
